import request from '@/utils/request'

// 查询用户是否为核销员
export function checkVerifier(userId) {
  return request({
    url: '/biz/admin/community/verifier/check',
    method: 'get',
    params: { userId }
  })
}

// 设为核销员
export function setVerifier(userId) {
  return request({
    url: '/biz/admin/community/verifier/set',
    method: 'post',
    params: { userId }
  })
}

// 取消核销员
export function cancelVerifier(userId) {
  return request({
    url: '/biz/admin/community/verifier/cancel',
    method: 'post',
    params: { userId }
  })
}